// extracted by mini-css-extract-plugin
module.exports = {"wishlist":"styles_wishlist__3V9Ei","wishlist-gallery":"styles_wishlist-gallery__1hzDg"};